import { LockClosedIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { getInitials } from '@/utils/identity'

type AccountSidebarProps = {
    name: string
    email?: string
    pictureUrl?: string | null
}

export const AccountSidebar = ({ name, email, pictureUrl }: AccountSidebarProps) => {
    const { t } = useTranslation()

    return (
        <aside className="flex w-full flex-shrink-0 flex-col gap-6 md:w-64">
            <div className="flex items-center gap-4 px-2">
                {pictureUrl ? (
                    <img src={pictureUrl} alt="" className="h-12 w-12 shrink-0 rounded-full object-cover" />
                ) : (
                    <div className="bg-account-accent-soft text-account-accent-text flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-lg font-bold">
                        {getInitials(name)}
                    </div>
                )}
                <div className="flex min-w-0 flex-col overflow-hidden">
                    <span className="text-account-strong truncate font-bold">{name}</span>
                    {email && <span className="text-account-secondary truncate text-xs">{email}</span>}
                </div>
            </div>

            <nav className="flex flex-col gap-1">
                <NavLink
                    to="security"
                    className={({ isActive }) =>
                        isActive
                            ? 'border-account-divider bg-account-surface text-account-accent-text flex items-center gap-3 rounded-lg border px-3 py-2.5 font-semibold shadow-sm'
                            : 'text-account-primary hover:bg-account-hover hover:text-account-strong flex items-center gap-3 rounded-lg border border-transparent px-3 py-2.5 font-semibold transition'
                    }
                >
                    {({ isActive }) => (
                        <>
                            <LockClosedIcon className={`h-5 w-5 ${isActive ? 'opacity-75' : 'text-account-faint'}`} />
                            {t('shell.securityNav')}
                        </>
                    )}
                </NavLink>
            </nav>
        </aside>
    )
}
